"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkTypeDto = exports.OptionalImageType = exports.PhotoType = exports.OptionalTextTypeDto = exports.TextType = void 0;
var TextType;
(function (TextType) {
    TextType["TXT"] = "txt";
    TextType["MD"] = "md";
})(TextType = exports.TextType || (exports.TextType = {}));
var OptionalTextTypeDto;
(function (OptionalTextTypeDto) {
    OptionalTextTypeDto["EMPTY"] = "empty";
    OptionalTextTypeDto["TEXT"] = "text";
})(OptionalTextTypeDto = exports.OptionalTextTypeDto || (exports.OptionalTextTypeDto = {}));
var PhotoType;
(function (PhotoType) {
    PhotoType["EMPTY"] = "empty";
    PhotoType["PHOTO"] = "photo";
    PhotoType["ID"] = "id";
})(PhotoType = exports.PhotoType || (exports.PhotoType = {}));
var OptionalImageType;
(function (OptionalImageType) {
    OptionalImageType["EMPTY"] = "empty";
    OptionalImageType["IMAGE"] = "image";
})(OptionalImageType = exports.OptionalImageType || (exports.OptionalImageType = {}));
var LinkTypeDto;
(function (LinkTypeDto) {
    LinkTypeDto["WEB"] = "web";
    LinkTypeDto["FB"] = "fb";
    LinkTypeDto["INSTAGRAM"] = "instagram";
    LinkTypeDto["LINKED_IN"] = "linkedIn";
    LinkTypeDto["TWITTER"] = "twitter";
    LinkTypeDto["YOUTUBE"] = "youtube";
    LinkTypeDto["VK"] = "vk";
    LinkTypeDto["TELEGRAM"] = "telegram";
    LinkTypeDto["PHONE"] = "phone";
    LinkTypeDto["EMAIL"] = "email";
    LinkTypeDto["WHATSAPP"] = "whatsapp";
})(LinkTypeDto = exports.LinkTypeDto || (exports.LinkTypeDto = {}));
